import React from "react";
import { useContext } from "react";
import { ThemeContext } from "../../../../../context/theme/ThemeContext";
import Style from "./announcelayout.module.scss";
import { Close, Filter, Search, Sort } from "@mui/icons-material";
import moment from "moment";
import AnnouncementData from "../../../../../data/announcement.json";
import { ModalLayout } from "../../../../../components";
import AnnounceView from "./AnnounceView";
import { authGetRequest } from "../../../../../api/laravel/public/api";
import {
  errorMessage,
  successMessage,
} from "../../../../../utils/notification";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

function AnnounceLayout(props) {
  const { theme, changeTheme } = useContext(ThemeContext);
  const [age, setAge] = React.useState("All");
  const [loading, setLoading] = React.useState(false);
  const [content, setContent] = React.useState(null);
  const [data, setData] = React.useState({});
  const [modal, setModal] = React.useState(false);
  const [ann, setAnn] = React.useState(false);
  const { announcement } = props;

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  React.useEffect(() => {

  }, []);

  const onAnnounce = (e) => {
    setContent(e);
    setModal(true);
  };



  const closeModal = () => { };
  return (
    <ul className="list-announcement">
      {announcement?.length == 0 && <h3 className="sm black">No Announcement</h3>}
      {announcement && Array.from(announcement).map((item, index) => (
        <li key={index} onClick={() => onAnnounce(item)}>
          <div className="list-body">
            <i className="icon mdi mdi-flag" />
            <div className="list-content">
              <h4 className="sm black bold">
                <a className="cursor-pointer" onClick={() => onAnnounce(item)} >{item?.title}</a>
              </h4>
              <p className="mr-4">{item?.description}</p>
              {/* <div className="author">By <Link to={"/instructor/detail/" + item?.created_by?.id}>{item?.created_by?.first_name} {item?.created_by?.last_name}</Link></div> */}
              <em>{moment(item?.created_at).fromNow()}</em>
            </div>
          </div>
        </li>
      ))}
      <ModalLayout
        padding={0}
        modal={modal}
        content={<div className="card p-4 m-0 bg-white">
          <div className="d-flex flex-row align-items-center justify-content-between w-100">
            <h4 className="h4"> {content?.title}</h4>
            <br />
            {/* <p className="black"><b>Description:</b> {content?.description}</p><br /> */}
            {/* <button className="btn btn-sm btn-danger mx-4">close</button> */}
          </div>
          <div className="d-flex flex-row align-items-center  my-3">

            <dd dangerouslySetInnerHTML={{ __html: content?.content }}>
             
            </dd>
          </div>
            <button onClick={()=>setModal(false)} className="mc-btn btn-style-2">Close</button>
        </div>}
      />
    </ul>

  );
}

export default AnnounceLayout;
